<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4">
        <h2 class="h h--2 h--dark">Zasady programu</h2>
        <br />
        <div class="rules-info">
          <h2 class="h h--3 h--green">Każde 1000 zł netto</h2>
          <p class="par21">wydane na fakturze to <strong>2 pkt</strong>,<br /> które można przeznaczyć</p>
          <h2 class="h h--3 h--green">na nagrody</h2>
        </div>

        <br />
        <div class="rules-info">
          <h2 class="h h--3 h--green">Wykonaj 2 kroki, aby otrzymać Certyfikat Geberit Pro</h2>
          <p class="par21">1. Zarejestruj faktury na łączną kwotę <strong>30.000 zł</strong></p>
          <p class="par21">2. Weź udział w szkoleniu certyfikującym i zalicz <strong>Test Wiedzy</strong></p>
        </div>
      </div>
      <div class="col-lg-8">
        <img src="../../../assets/img/infografika-big.png" class="volex-banner__desktop rules-banner">
      </div>
    </div>


    <h2 class="h h--4 h--dark">Twoje korzyści</h2>
    <div class="row profits">
      <div class="col-md-4 profits__profit">
        <div class="profits__single">
          <div class="profits__img">
            <img src="../../../assets/img/profit1.png" >
          </div>
          <div class="profits__desc">
            <strong>Partnerstwo z firmą Geberit</strong> – określona, wąska grupa specjalistów
          </div>
        </div>
      </div>
      <div class="col-md-4 profits__profit">
        <div class="profits__single">
          <div class="profits__img">
            <img src="../../../assets/img/profit2.png" >
          </div>
          <div class="profits__desc">
            Startowy, atrakcyjny <strong>pakiet korzyści</strong> – ubrania, wizytówki, oklejanie samochodów
          </div>
        </div>
      </div>
      <div class="col-md-4 profits__profit">
        <div class="profits__single">
          <div class="profits__img">
            <img src="../../../assets/img/profit3.png" >
          </div>
          <div class="profits__desc">
            <strong>Atrakcyjne nagrody</strong> – w ramach specjalnych akcji promcyjnych, możliwość wymiany na praktycznie dowolnie wybrane nagrody – „więcej kupujesz – zyskujesz”
          </div>
        </div>
      </div>
      <div class="col-md-4 profits__profit">
        <div class="profits__single">
          <div class="profits__img">
            <img src="../../../assets/img/profit4.png" >
          </div>
          <div class="profits__desc">
            <strong>Możliwość wymiany doświadczeń</strong> z najlepszymi instalatorami, w ramach organizowanych szkoleń, eventów i poprzez narzędzia internetowe
          </div>
        </div>
      </div>
      <div class="col-md-4 profits__profit">
        <div class="profits__single">
          <div class="profits__img">
            <img src="../../../assets/img/profit5.png" >
          </div>
          <div class="profits__desc">
            <strong>Dedykowana osoba do „ekspresowego” wsparcia</strong> + pakiet korzyści sprzętowych – będziesz mógł liczyć na dostęp do bezpłatnej wypożyczalni narzędzi, ekspresową dostawę produktów w przypadku awarii oraz specjalny kalkulator do obliczeń instalacji
          </div>
        </div>
      </div>
      <div class="col-md-4 profits__profit">
        <div class="profits__single">
          <div class="profits__img">
            <img src="../../../assets/img/profit6.png" >
          </div>
          <div class="profits__desc">
            <strong>Osobiste konto na platformie internetowej</strong> – dzięki niej wiesz na bieżąco wszystko i dowolnie dysponujesz środkami. Masz realny wpływ na to co będzie dostarczane jako najbardziej pożądana wartość
          </div>
        </div>
      </div>
      <div class="col-md-4 profits__profit">
        <div class="profits__single">
          <div class="profits__img">
            <img src="../../../assets/img/profit7.png" >
          </div>
          <div class="profits__desc">
            Twoje usługi będą polecane na stronie <strong>www.geberit.pl</strong>
          </div>
        </div>
      </div>
    </div>


    <page-box-set-widget></page-box-set-widget>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'RulesComponent',
    data () {
      return {
      }
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/home/rules/RulesComponent.vue